import React from 'react';
import { VStack, Text } from '@chakra-ui/react';

interface CustomFieldTextDetailedProps {
  label: string;
  value: string;
}

const CustomFieldTextDetailed: React.FC<
  CustomFieldTextDetailedProps
> = ({ label, value }) => {
  return (
    <VStack gap="0.5rem" align='flex-start' width="100%">
      <Text
        color="text.primary"
        fontSize="0.75rem"
        fontStyle="normal"
        fontWeight="400"
        lineHeight="1rem"
      >
        {label}
      </Text>
      <Text
        color="text.primary"
        fontSize="0.75rem"
        fontStyle="normal"
        fontWeight="700"
        lineHeight="1rem"
      >
        {value}
      </Text>
    </VStack>
  );
};

export default CustomFieldTextDetailed;
